import $ from "jquery";

function hasBurger() {
    return $('.nav-burger').is(':visible');
}

$(document).on('click', '.nav-secondary-item a', function(e) {
    const subnav = $('.nav-secondary');
    if (subnav.length && hasBurger()) {
        subnav.toggleClass('nav-secondary--opened');
        if (subnav.hasClass('nav-secondary--opened')) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    }
});

$(document).on('click', function(e) {
    if (!$(e.target).closest('.nav-secondary').length) {
        $('.nav-secondary').removeClass('nav-secondary--opened');
    }
});

$(document).on('click', '.nav-burger', function(e) {
    e.preventDefault();
    $(this).parents('.nav').toggleClass('nav--opened');
});

$(document).on('click', 'main, .nav-wrapper a[href]', function(e) {
    const subnav = $(this).siblings('.nav-subitems');
    if (!subnav.length) {
        $('.nav').removeClass('nav--opened');
    }
});

$(document).on('click', '.nav-item a', function(e) {
    const subnav = $(this).siblings('.nav-subitems');
    if (subnav.length && hasBurger()) {
        e.preventDefault();
        if (subnav.is(':visible')) {
            $(this).removeClass('active');
            subnav.slideUp();
        } else {
            $(this).addClass('active');
            subnav.slideDown();
        }
    }
});
